"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var _ = tslib_1.__importStar(require("@antv/util"));
var global_1 = require("../../base/global");
require("../scatter/components/label/scatter-label");
var EventParser = tslib_1.__importStar(require("../scatter/event"));
var layer_1 = tslib_1.__importDefault(require("../scatter/layer"));
var BubbleLayer = /** @class */ (function (_super) {
    tslib_1.__extends(BubbleLayer, _super);
    function BubbleLayer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = 'bubble';
        return _this;
    }
    BubbleLayer.getDefaultOptions = function () {
        return _.deepMix({}, _super.getDefaultOptions.call(this), {
            pointSize: [8, 58],
            pointStyle: {
                strokeOpacity: 1,
                fillOpacity: 1,
                opacity: 0.5,
            },
            label: {
                position: 'middle',
            },
        });
    };
    BubbleLayer.prototype.legend = function () {
        var _a;
        _super.prototype.legend.call(this);
        /** 取消气泡大小图例 */
        this.setConfig('legends', {
            fields: (_a = {},
                _a[this.options.sizeField] = false,
                _a),
        });
    };
    BubbleLayer.prototype.parseEvents = function () {
        _super.prototype.parseEvents.call(this, EventParser);
    };
    return BubbleLayer;
}(layer_1.default));
exports.default = BubbleLayer;
global_1.registerPlotType('bubble', BubbleLayer);
//# sourceMappingURL=layer.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@antv/g2plot/lib/plots/bubble/layer.js
// module id = 882
// module chunks = 37